export function bceNumberValidate(bce: string) {
  try {
    const cleaned = bce.replace(/\./g, "");
    if (cleaned.length !== 10) return false;
    const numberToValidate = cleaned.slice(0, 8);
    const validator = cleaned.slice(8);
    return 97 - (+numberToValidate % 97) === +validator;
  } catch {
    return false;
  }
}
